import { lazy, Suspense } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { WalletButton } from "./WalletButton";
import { appName, isMainnet, adminAccounts, contracts } from "../config";
import { useWallet } from "../wallet/WalletContext";

// Polygon pages use MetaMask, not the WAX login. Lazy so viem only loads there.
const PolygonWalletButton = lazy(() => import("./PolygonWalletButton").then((m) => ({ default: m.PolygonWalletButton })));

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? "nav-link nav-link--active" : "nav-link");

export function Header() {
  const { account } = useWallet();
  const { pathname } = useLocation();
  const onPolygonPage = pathname.startsWith("/create/polygon") || pathname.startsWith("/polygon");
  const isAdmin = !!account && (adminAccounts.includes(account) || account === contracts.orderbook);

  return (
    <header className="header">
      <div className="header__inner">
        <NavLink to="/" className="header__brand">
          🪄 {appName}
        </NavLink>
        <nav className="header__nav">
          <NavLink to="/create" end className={navLinkClass}>
            Create NFT
          </NavLink>
          <NavLink to="/create/polygon" className={navLinkClass}>
            Create on Polygon
          </NavLink>
          <NavLink to="/polygon" className={navLinkClass}>
            Polygon NFTs
          </NavLink>
          <NavLink to="/drops" className={navLinkClass}>
            Drops
          </NavLink>
          <NavLink to="/" end className={navLinkClass}>
            Marketplace
          </NavLink>
          <NavLink to="/exchange" className={navLinkClass}>
            Exchange
          </NavLink>
          <NavLink to="/recently-sold" className={navLinkClass}>
            Recently Sold
          </NavLink>
          <NavLink to="/inventory" className={navLinkClass}>
            My Assets
          </NavLink>
          <NavLink to="/mint" className={navLinkClass}>
            Back an NFT
          </NavLink>
          <NavLink to="/create-advanced" className={navLinkClass}>
            Advanced
          </NavLink>
          <NavLink to="/create-bulk" className={navLinkClass}>
            Bulk Create
          </NavLink>
          <NavLink to="/create-drop" className={navLinkClass}>
            Create Drop
          </NavLink>
          <NavLink to="/forum" className={navLinkClass}>
            Forum
          </NavLink>
          <NavLink to="/tutorials" className={navLinkClass}>
            Tutorials
          </NavLink>
          <NavLink to="/developers" className={navLinkClass}>
            API
          </NavLink>
          {isAdmin && (
            <NavLink to="/admin" className={navLinkClass}>
              Admin
            </NavLink>
          )}
        </nav>
        <div className="header__actions">
          {!isMainnet && !onPolygonPage && <span className="network-pill">TESTNET</span>}
          {onPolygonPage ? (
            <Suspense fallback={null}>
              <PolygonWalletButton />
            </Suspense>
          ) : (
            <WalletButton />
          )}
        </div>
      </div>
    </header>
  );
}
